<div>
    <h5>My Study Materials</h5>
    <table
        class="table"
        *ngIf="products"
    >
        <thead>
            <tr>
                <th
                    class="text-center"
                    width="120"
                >Expiry Date</th>
                <th>Product</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of products">
                <td class="grey">
                    <div
                        class="text-center"
                        *ngIf="item.expiryDateTime"
                    >{{item.expiryDateTime}}</div>
                    <div
                        class="text-center"
                        *ngIf="item.expired"
                        style="padding-top:7px; color:red;"
                    >
                        Expired
                    </div>
                </td>
                <td>
                    <div *ngIf="!item.expired">
                        <a
                            class="product-link"
                            *ngIf="!item.gotError"
                            (click)="productClick($event, item)"
                        >
                            {{item.productName}}
                        </a>

                        <div *ngIf="item.gotError">
                            <div>{{item.productName}}</div>
                            <br>
                            <p>{{item.expiryDateTime}} {{item.gotError}}</p>
                            <b style="color:crimson">There was an error loading the product. Please
                                <a
                                    href="{{contactUrl}}"
                                    target="_blank"
                                    style="color:blue"
                                >contact us</a> to have the issue resolved.
                            </b>
                        </div>

                        <div *ngIf="hasCaelPrepAudioFiles">
                            <span>
                                Click <a [routerLink]="['/cael-prep/audio-files']">here</a> to access audio files
                            </span>
                        </div>

                        <div *ngIf="brandId === BrandEnum.CELPIP">
                            <p *ngIf="celpipStudyGuideListeningSpeakingproductIds.indexOf(item.productId)>-1">Click <a
                                    href="{{celpipStudyGuideListeningSpeakingUrl}}"
                                    target="_blank"
                                >here</a> to access updates and media. </p>
                            <p *ngIf="celpipStudyGuideReadingWritingproductIds.indexOf(item.productId)>-1">Click <a
                                    href="{{celpipStudyGuideReadingWritingUrl}}"
                                    target="_blank"
                                >here</a> to access updates. </p>
                            <!-- todo: check later if the products are retired -->
                            <div *ngIf="item.productTypeId === productOptionTypeId">
                                <br /> &bull;
                                Introduction to the CELPIP Tests: Speaking (25-minute video & PDF) <br />
                                To become familiar with the format of the Speaking Test, see each question type, and learn about the Performance Standards,
                                please
                                <a
                                    href="https://meet71205292.adobeconnect.com/p5wqbz97635/"
                                    target="_blank"
                                >view the video</a> or
                                <a
                                    href=""
                                    (click)="downloadPDF('Introduction to the Speaking Test.pdf')"
                                >download</a> the PDF version.
                                <br />&bull;
                                How to Use Adobe Connect (17-minute video & PDF) <br />
                                To learn about the Adobe Connect tools and features you will use in the course,
                                please
                                <a
                                    href="https://meet71205292.adobeconnect.com/p4ncxla2623/"
                                    target="_blank"
                                >view the video</a> or
                                <a
                                    href=""
                                    (click)="downloadPDF('How to Use Adobe Connect.pdf')"
                                >download</a> the PDF version.
                                <br />&bull;
                                Performance Standards for the Speaking Test (PDF) <br />
                                Please
                                <a
                                    href=""
                                    (click)="downloadPDF('Performance Standards.pdf')"
                                >download</a>
                                and print a copy of the Performance Standards PDF and have it ready for each lesson.
                            </div>
                        </div>
                    </div>

                    <div *ngIf="item.expired">
                        <div>{{item.productName}}</div>
                        <a
                            class="btn btn-primary my-2"
                            [routerLink]="['/product-shopping']"
                            [queryParams]="{productId : item.productId}"
                        >buy now</a>
                    </div>
                    <small class="m-0">{{item.productType}}</small>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!--Modal Body-->
<ng-template
    #ConfirmDownload
    let-modal
>
    <div class="modal-header">
        <h5 class="modal-title text-center text-uppercase">Document Ready</h5>
    </div>
    <div class="modal-body text-center">
        <span>Click <a
                style="color:#A6192E"
                (click)="downloadEbook()"
            >here</a> to download file</span>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-outline-dark"
            (click)="modal.close('ok click');"
        >close</button>
    </div>
</ng-template>
